const PATTERNS = {
  EMAIL: /^(\w+[\w-+\\.]*)@(\w+([-\\.]\w+)*\.[a-zA-Z]{2,})$/,
  PASSWORD: /^.{7,}$/,
};

export default PATTERNS;
